import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import StrategyHero from '@/components/sections/strategy/StrategyHero'
import StrategyServices from '@/components/sections/strategy/StrategyServices'
import StrategyPricing from '@/components/sections/strategy/StrategyPricing'
import StrategyContact from '@/components/sections/strategy/StrategyContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Strategy() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'Digital Consulting', description: "Executable roadmaps that align your digital ecosystem with actual business goals. No fluff, just momentum.", path: '/strategy' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Strategy', path: '/strategy' }])} />
      <Navbar />
      <main>
        <StrategyHero />
        <StrategyServices />
        <StrategyPricing />
        <StrategyContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
